import {
  template_hindi,
  template_japanese,
  template_korean,
  template_zh_tw,
} from "./template";
import {
  credentials_zh_tw,
  credentialsHindi,
  credentialsJapanese,
  credentialsKorean,
} from "./credentials";
import {
  sequence_detail_steps_hindi,
  sequence_detail_steps_japanese,
  sequence_detail_steps_korean,
  sequence_detail_steps_zh_tw,
} from "./detail_steps";
import {
  sequence_detail_settings_hindi,
  sequence_detail_settings_japanese,
  sequence_detail_settings_korean,
  sequence_detail_settings_zhHant,
} from "./detail_settings";
import {
  sequence_detail_logs_hindi,
  sequence_detail_logs_japanese,
  sequence_detail_logs_korean,
  sequence_detail_logs_zh_tw,
} from "./detail_logs";
import {
  sequence_detail_targets_hindi,
  sequence_detail_targets_japanese,
  sequence_detail_targets_korean,
  sequence_detail_targets_zhHant,
} from "./detail_targets";

import {
  sequence_detail_report_zhTW,
  sequence_detail_report_ja,
  sequence_detail_report_ko,
  sequence_detail_report_hi,
} from "./detail_report";

import {
  sequence_wizard_zh_tw,
  sequence_wizard_ja,
  sequence_wizard_ko,
  sequence_wizard_hi,
} from "./wizard";
export default {
  sequence_main_timeout_title:
    "設定於 {datetime} 啟用。您可以隨時在下方重新排程。",
  /** tabs */
  sequence_tab_overview: "總覽",
  sequence_tab_templates: "範本",
  sequence_tab_analytics: "分析",
  sequence_tab_meetings: "會議",
  sequence_tab_credentials: "憑證",
  sequence_tab_settings: "設定",

  /** aside */
  sequence_overview_aside_create_new_label: "建立新標籤",
  sequence_overview_labels_total: "0 工作流程 | 1 工作流程 | {count} 工作流程",

  /** label form */
  sequence_overview_label_create_dialog_name: "新增標籤",
  sequence_overview_label_edit_dialog_name: "重新命名標籤",
  sequence_overview_label_create_dialog_input_label: "請輸入新標籤名稱",
  sequence_overview_label_edit_dialog_input_label: "請輸入標籤名稱",
  sequence_overview_label_create_dialog_input_oplaceholder: "輸入新標籤名稱",
  sequence_overview_label_edit_dialog_input_placeholder: "輸入標籤名稱",
  create_sequence_label_success: "標籤已建立",
  create_sequence_label_failed: "建立失敗",
  update_sequence_label_success: "更新成功",
  update_sequence_label_failed: "更新失敗",

  /** filters */
  sequence_overview_filters_creator: "建立者",
  sequence_overview_filters_label: "標籤",
  sequence_overview_filters_starred: "已加星標",
  sequence_overview_filters_state: "狀態",
  sequence_filter_status_active: "啟用",
  sequence_filter_status_inactive: "未啟用",

  /** table */
  sequence_overview_table_label_panel_empty:
    "您尚未建立任何標籤。點擊「⊕」按鈕以建立第一個標籤並開始整理！",
  sequence_overview_label_panel_search_placeholder: "搜尋標籤",
  add_label_to_sequence_successfully: "新增成功",
  add_label_to_sequence_failed: "新增失敗",
  remove_label_from_sequence_successfully: "移除成功",
  remove_label_from_sequence_failed: "移除失敗",

  sequence_overview_table_name_sequence_name: "工作流程名稱",
  sequence_overview_table_name_people: "人員",
  sequence_overview_table_name_click_rate: "點擊率",
  sequence_overview_table_name_open_rate: "開啟率",
  sequence_overview_table_name_reply_rate: "回覆率",
  sequence_overview_unsave_count:
    "未選取任何工作流程 | 已選取一個工作流程 | 已選取 {count} 個工作流程",

  /** create sequence */
  sequence_overview_create_sequence_dialog_name: "新增工作流程",
  sequence_overview_create_sequence_dialog_input_label: "請輸入工作流程名稱",
  sequence_overview_create_sequence_dialog_input_placeholder: "工作流程名稱",

  /** detail empty */
  sequence_detail_error_title: "哎呀！我們無法取得資料。",
  sequence_detail_error_desc:
    "連結可能不正確或資料無法取得。請檢查網址或更換所選項目後再試一次。",
  sequence_detail_error_back: "返回工作流程清單",

  /** detail header */
  sequence_detail_delete: "刪除此工作流程",
  sequence_detail_delete_dialog_title: "刪除工作流程",
  sequence_detail_delete_dialog_subtitle:
    "這將刪除整個工作流程，包括所有設定與資料。",
  sequence_detail_delete_dialog_desc:
    "刪除後，該工作流程將無法恢復。您確定要繼續嗎？",

  /** detail nav */
  sequence_detail_nav_inbox: "收件匣",
  sequence_detail_nav_steps: "步驟",
  sequence_detail_nav_report: "報告",
  sequence_detail_nav_analytics: "分析",
  sequence_detail_nav_prospects: "潛在客戶",
  sequence_detail_nav_settings: "設定",
  sequence_detail_nav_logs: "日誌",
  sequence_detail_nav_interactions: "互動",

  /** detail step canvas */
  sequence_detail_workflow_time_delay: "延遲",
  sequence_detail_workflow_time_monitor: "監控",
  sequence_detail_workflow_time_run_immediately: "立即執行",
  sequence_detail_steps_add_first_step: "新增第一個步驟...",

  /** detail step canvas create node */
  sequence_detail_workflow_create_node_level1_title: "接下來會發生什麼？",
  sequence_detail_workflow_create_node_level2_title: "選擇通道",
  sequence_detail_workflow_create_node_level3_title: "選擇條件/動作類型",

  /** detail step setting panel credential */
  sequence_detail_setting_credential_label: "憑證：",
  sequence_detail_setting_credential_primary_flag: "主要",
  sequence_detail_setting_credential_primary_opeator: "設為主要",
  sequence_workflow_unsave_changes_title: "尚未儲存的變更",
  sequence_workflow_unsave_changes_desc:
    "您有尚未儲存的變更。您可以儲存變更或離開此頁面並放棄變更。",
  leave: "離開",
  discard: "放棄",
  sequence_workflow_version_unsaved_changes_description:
    "目前版本有尚未儲存的變更。您可以返回編輯或儲存變更。",
  sequence_workflow_version_invalid_dialog_title: "目前流程圖中有未驗證的欄位",
  sequence_workflow_version_invalid_dialog_primary_button: "返回目前版本",
  sequence_workflow_version_invalid_dialog_description:
    "目前版本中有未驗證的欄位。您可以返回更新這些欄位或放棄變更。",
  back: "返回",
  editor_toolbar_image_upload: "上傳",
  editor_toolbar_image_url: "連結",
  choose_file: "選擇檔案",
  to_upload: "上傳",
  editor_toolbar_image_popover_url_label: "圖片連結",
  insert: "插入",

  set_schedule: "設定排程",
  sequence_main_schedule_title: "排程工作流程",
  start_now: "立即開始",
  schedule_start: "排程開始時間",
  activate_sequence: "啟動工作流程",
  sequence_no_credentials_banner_title:
    "連結您的電子郵件或訊息帳號，以便透過 Pubrio 傳送工作流程",
  sequence_no_credentials_banner_title_suffix: " · 少於 5 分鐘",
  sequence_no_credentials_banner_desc:
    "在開始或傳送任何工作流程前，必須先完成此設定。",
  sequence_no_credentials_banner_button: "連結寄送帳號",
  sequence_detail_out_of_schedule_popup_message:
    "工作流程已啟動，但目前不在發送時段內。系統現時不會發送任何訊息。發送時段為 {0}。將於 {1} 恢復發送。",
  sequence_list_out_of_schedule_popup_message:
    "提醒：目前不在您的發送時段內（{0}）。工作流程會先啟動，但第一則訊息將於 {1} 才會發出。",
  dismiss: "關閉",
  edit_schedule: "編輯發送時段",
  broken_steps_popup_message:
    "預設版本中某些步驟不完整 — 請修復後再啟用工作流程。",
  broken_step_save_warning_title: "儲存為草稿？",
  broken_step_save_warning_desc_1: "部分步驟尚未完成。",
  broken_step_save_warning_desc_2:
    "您可以先儲存為草稿，之後再回來編輯，但在所有步驟完成前，這個工作流程無法啟用。",
  broken_step_save_warning_primary_button_text: "儲存為草稿",
  broken_step_save_warning_default_button_text: "繼續編輯",
  broken_step_disable_activation_warning_title: "儲存未完成步驟？",
  broken_step_disable_activation_warning_primary_button_text: "儲存並暫停",
  broken_step_disable_activation_warning_default_button_text: "繼續編輯",
  broken_step_disable_activation_warning_desc_1: "此工作流程目前已啟用。",
  broken_step_disable_activation_warning_desc_2:
    "現在儲存會使其暫停，直到所有步驟完成並重新啟用。",
  ...template_zh_tw,
  ...credentials_zh_tw,
  ...sequence_detail_steps_zh_tw,
  ...sequence_detail_settings_zhHant,
  ...sequence_detail_logs_zh_tw,
  ...sequence_detail_targets_zhHant,
  ...sequence_detail_report_zhTW,
  ...sequence_wizard_zh_tw,
};

export const sequence_japanese = {
  sequence_main_timeout_title:
    "{datetime} に有効化されるよう設定されています。下記からいつでも再スケジュール可能です。",

  /** tabs */
  sequence_tab_overview: "概要",
  sequence_tab_templates: "テンプレート",
  sequence_tab_analytics: "分析",
  sequence_tab_meetings: "会議",
  sequence_tab_credentials: "認証情報",
  sequence_tab_settings: "設定",

  /** aside */
  sequence_overview_aside_create_new_label: "新規ラベル作成",
  sequence_overview_labels_total:
    "0 ワークフロー | 1 ワークフロー | {count} ワークフロー",

  /** label form */
  sequence_overview_label_create_dialog_name: "ラベル追加",
  sequence_overview_label_edit_dialog_name: "ラベル名変更",
  sequence_overview_label_create_dialog_input_label:
    "新しいラベル名を入力してください",
  sequence_overview_label_edit_dialog_input_label: "ラベル名を入力してください",
  sequence_overview_label_create_dialog_input_oplaceholder:
    "新しいラベル名を入力",
  sequence_overview_label_edit_dialog_input_placeholder: "ラベル名を入力",
  create_sequence_label_success: "ラベルが作成されました",
  create_sequence_label_failed: "作成失敗",
  update_sequence_label_success: "更新成功",
  update_sequence_label_failed: "更新失敗",

  /** filters */
  sequence_overview_filters_creator: "作成者",
  sequence_overview_filters_label: "ラベル",
  sequence_overview_filters_starred: "スター付き",
  sequence_overview_filters_state: "状態",
  sequence_filter_status_active: "有効",
  sequence_filter_status_inactive: "無効",

  /** table */
  sequence_overview_table_label_panel_empty:
    "まだラベルを作成していません。「⊕」ボタンをクリックして最初のラベルを作成し、整理を始めましょう！",
  sequence_overview_label_panel_search_placeholder: "ラベルを検索",
  add_label_to_sequence_successfully: "追加成功",
  add_label_to_sequence_failed: "追加失敗",
  remove_label_from_sequence_successfully: "削除成功",
  remove_label_from_sequence_failed: "削除失敗",

  sequence_overview_table_name_sequence_name: "ワークフロー名",
  sequence_overview_table_name_people: "担当者",
  sequence_overview_table_name_click_rate: "クリック率",
  sequence_overview_table_name_open_rate: "開封率",
  sequence_overview_table_name_reply_rate: "返信率",
  sequence_overview_unsave_count:
    "ワークフローが選択されていません | 1つのワークフローが選択されています | {count}つのワークフローが選択されています",

  /** create sequence */
  sequence_overview_create_sequence_dialog_name: "ワークフロー追加",
  sequence_overview_create_sequence_dialog_input_label:
    "ワークフロー名を入力してください",
  sequence_overview_create_sequence_dialog_input_placeholder: "ワークフロー名",

  /** detail empty */
  sequence_detail_error_title: "エラーが発生しました",
  sequence_detail_error_desc:
    "リンクが正しくないか、データを取得できませんでした。URLを確認するか、別の項目を選択して再試行してください。",
  sequence_detail_error_back: "ワークフロー一覧に戻る",

  /** detail header */
  sequence_detail_delete: "このワークフローを削除",
  sequence_detail_delete_dialog_title: "ワークフロー削除",
  sequence_detail_delete_dialog_subtitle:
    "これにより、すべての設定とデータを含むワークフロー全体が削除されます。",
  sequence_detail_delete_dialog_desc:
    "削除後、このワークフローは復元できません。本当に続行しますか？",

  /** detail nav */
  sequence_detail_nav_inbox: "受信箱",
  sequence_detail_nav_steps: "ステップ",
  sequence_detail_nav_report: "レポート",
  sequence_detail_nav_analytics: "分析",
  sequence_detail_nav_prospects: "見込み客",
  sequence_detail_nav_settings: "設定",
  sequence_detail_nav_logs: "ログ",
  sequence_detail_nav_interactions: "インタラクション",

  /** detail step canvas */
  sequence_detail_workflow_time_delay: "遅延",
  sequence_detail_workflow_time_monitor: "監視",
  sequence_detail_workflow_time_run_immediately: "すぐに実行",
  sequence_detail_steps_add_first_step: "最初のステップを追加...",

  /** detail step canvas create node */
  sequence_detail_workflow_create_node_level1_title: "次に何が起こりますか？",
  sequence_detail_workflow_create_node_level2_title: "チャネルを選択",
  sequence_detail_workflow_create_node_level3_title:
    "条件/アクションタイプを選択",

  /** detail step setting panel credential */
  sequence_detail_setting_credential_label: "認証情報：",
  sequence_detail_setting_credential_primary_flag: "プライマリ",
  sequence_detail_setting_credential_primary_opeator: "プライマリに設定",
  sequence_workflow_unsave_changes_title: "保存されていない変更",
  sequence_workflow_unsave_changes_desc:
    "保存されていない変更があります。変更を保存するか、このページを離れて変更を破棄できます。",
  leave: "離れる",
  discard: "破棄",
  sequence_workflow_version_unsaved_changes_description:
    "現在のバージョンに保存されていない変更があります。編集に戻るか、変更を保存できます。",
  sequence_workflow_version_invalid_dialog_title:
    "現在のフローチャートに未検証のフィールドがあります",
  sequence_workflow_version_invalid_dialog_primary_button:
    "現在のバージョンに戻る",
  sequence_workflow_version_invalid_dialog_description:
    "現在のバージョンに未検証のフィールドがあります。これらのフィールドを更新するか、変更を破棄できます。",
  back: "戻る",
  editor_toolbar_image_upload: "アップロード",
  editor_toolbar_image_url: "リンク",
  choose_file: "ファイルを選択",
  to_upload: "アップロード",
  editor_toolbar_image_popover_url_label: "画像リンク",
  insert: "挿入",
  set_schedule: "スケジュール設定",
  sequence_main_schedule_title: "シーケンスのスケジュール",
  start_now: "今すぐ開始",
  schedule_start: "スケジュール開始",
  activate_sequence: "シーケンスを有効化",
  sequence_no_credentials_banner_title:
    "Pubrio からシーケンスを送信するにはメールまたはメッセージングアカウントを接続してください",
  sequence_no_credentials_banner_title_suffix: " · 5 分未満",
  sequence_no_credentials_banner_desc:
    "シーケンスを開始または送信する前にこのセットアップが必要です。",
  sequence_no_credentials_banner_button: "送信アカウントを接続",
  sequence_detail_out_of_schedule_popup_message:
    "シーケンスは有効ですが、現在は送信スケジュール外です。現在メッセージは送信されません。送信可能時間は {0} です。{1} に送信を再開します。",
  sequence_list_out_of_schedule_popup_message:
    "お知らせ：現在は送信スケジュール外です（{0}）。シーケンスは有効化されますが、最初のメッセージ送信は {1} から開始されます。",
  dismiss: "閉じる",
  edit_schedule: "送信スケジュールを編集",
  broken_steps_popup_message:
    "デフォルト版の一部ステップが未完成です — 有効化するには修正してください。",
  broken_step_save_warning_title: "下書きとして保存しますか？",
  broken_step_save_warning_desc_1: "一部のステップがまだ完了していません。",
  broken_step_save_warning_desc_2:
    "下書きとして保存して後で戻れますが、すべて完了するまでこのワークフローは有効化できません。",
  broken_step_save_warning_primary_button_text: "下書きとして保存",
  broken_step_save_warning_default_button_text: "編集を続ける",
  broken_step_disable_activation_warning_title: "未完了のステップを保存しますか？",
  broken_step_disable_activation_warning_primary_button_text: "保存して一時停止",
  broken_step_disable_activation_warning_default_button_text: "編集を続ける",
  broken_step_disable_activation_warning_desc_1:
    "このワークフローは現在有効です。",
  broken_step_disable_activation_warning_desc_2:
    "今保存すると、すべてのステップが完了して再有効化されるまで一時停止します。",
  ...template_japanese,
  ...credentialsJapanese,
  ...sequence_detail_steps_japanese,
  ...sequence_detail_settings_japanese,
  ...sequence_detail_logs_japanese,
  ...sequence_detail_targets_japanese,
  ...sequence_detail_report_ja,
  ...sequence_wizard_ja,
};

export const sequence_korean = {
  sequence_main_timeout_title:
    "{datetime}에 활성화되도록 설정되었습니다. 아래에서 언제든지 다시 일정할 수 있습니다.",

  /** tabs */
  sequence_tab_overview: "개요",
  sequence_tab_templates: "템플릿",
  sequence_tab_analytics: "분석",
  sequence_tab_meetings: "회의",
  sequence_tab_credentials: "인증 정보",
  sequence_tab_settings: "설정",

  /** aside */
  sequence_overview_aside_create_new_label: "새 라벨 생성",
  sequence_overview_labels_total:
    "0 워크플로우 | 1 워크플로우 | {count} 워크플로우",

  /** label form */
  sequence_overview_label_create_dialog_name: "라벨 추가",
  sequence_overview_label_edit_dialog_name: "라벨 이름 변경",
  sequence_overview_label_create_dialog_input_label:
    "새 라벨 이름을 입력하세요",
  sequence_overview_label_edit_dialog_input_label: "라벨 이름을 입력하세요",
  sequence_overview_label_create_dialog_input_oplaceholder: "새 라벨 이름 입력",
  sequence_overview_label_edit_dialog_input_placeholder: "라벨 이름 입력",
  create_sequence_label_success: "라벨이 생성되었습니다",
  create_sequence_label_failed: "생성 실패",
  update_sequence_label_success: "업데이트 성공",
  update_sequence_label_failed: "업데이트 실패",

  /** filters */
  sequence_overview_filters_creator: "생성자",
  sequence_overview_filters_label: "라벨",
  sequence_overview_filters_starred: "별표",
  sequence_overview_filters_state: "상태",
  sequence_filter_status_active: "활성화",
  sequence_filter_status_inactive: "비활성화",

  /** table */
  sequence_overview_table_label_panel_empty:
    "아직 라벨을 생성하지 않았습니다. '⊕' 버튼을 클릭하여 첫 번째 라벨을 생성하고 정리를 시작하세요!",
  sequence_overview_label_panel_search_placeholder: "라벨 검색",
  add_label_to_sequence_successfully: "추가 성공",
  add_label_to_sequence_failed: "추가 실패",
  remove_label_from_sequence_successfully: "삭제 성공",
  remove_label_from_sequence_failed: "삭제 실패",

  sequence_overview_table_name_sequence_name: "워크플로우 이름",
  sequence_overview_table_name_people: "담당자",
  sequence_overview_table_name_click_rate: "클릭률",
  sequence_overview_table_name_open_rate: "열람률",
  sequence_overview_table_name_reply_rate: "회신률",
  sequence_overview_unsave_count:
    "워크플로우가 선택되지 않음 | 1개의 워크플로우 선택됨 | {count}개의 워크플로우 선택됨",

  /** create sequence */
  sequence_overview_create_sequence_dialog_name: "워크플로우 추가",
  sequence_overview_create_sequence_dialog_input_label:
    "워크플로우 이름을 입력하세요",
  sequence_overview_create_sequence_dialog_input_placeholder: "워크플로우 이름",

  /** detail empty */
  sequence_detail_error_title: "오류가 발생했습니다",
  sequence_detail_error_desc:
    "링크가 올바르지 않거나 데이터를 가져올 수 없습니다. URL을 확인하거나 다른 항목을 선택한 후 다시 시도하세요.",
  sequence_detail_error_back: "워크플로우 목록으로 돌아가기",

  /** detail header */
  sequence_detail_delete: "이 워크플로우 삭제",
  sequence_detail_delete_dialog_title: "워크플로우 삭제",
  sequence_detail_delete_dialog_subtitle:
    "이 작업은 모든 설정과 데이터를 포함한 전체 워크플로우를 삭제합니다.",
  sequence_detail_delete_dialog_desc:
    "삭제 후에는 이 워크플로우를 복구할 수 없습니다. 정말로 계속하시겠습니까?",

  /** detail nav */
  sequence_detail_nav_inbox: "수신함",
  sequence_detail_nav_steps: "단계",
  sequence_detail_nav_report: "보고서",
  sequence_detail_nav_analytics: "분석",
  sequence_detail_nav_prospects: "잠재고객",
  sequence_detail_nav_settings: "설정",
  sequence_detail_nav_logs: "로그",
  sequence_detail_nav_interactions: "상호작용",

  /** detail step canvas */
  sequence_detail_workflow_time_delay: "지연",
  sequence_detail_workflow_time_monitor: "모니터링",
  sequence_detail_workflow_time_run_immediately: "즉시 실행",
  sequence_detail_steps_add_first_step: "첫 번째 단계 추가...",

  /** detail step canvas create node */
  sequence_detail_workflow_create_node_level1_title:
    "다음에 무엇이 발생하나요?",
  sequence_detail_workflow_create_node_level2_title: "채널 선택",
  sequence_detail_workflow_create_node_level3_title: "조건/작업 유형 선택",

  /** detail step setting panel credential */
  sequence_detail_setting_credential_label: "인증 정보:",
  sequence_detail_setting_credential_primary_flag: "기본",
  sequence_detail_setting_credential_primary_opeator: "기본으로 설정",
  sequence_workflow_unsave_changes_title: "저장되지 않은 변경 사항",
  sequence_workflow_unsave_changes_desc:
    "저장되지 않은 변경 사항이 있습니다. 변경 사항을 저장하거나 이 페이지를 떠나 변경 사항을 취소할 수 있습니다.",
  leave: "나가기",
  discard: "취소",
  sequence_workflow_version_unsaved_changes_description:
    "현재 버전에 저장되지 않은 변경 사항이 있습니다. 편집으로 돌아가거나 변경 사항을 저장할 수 있습니다.",
  sequence_workflow_version_invalid_dialog_title:
    "현재 플로우 차트에 유효하지 않은 필드가 있습니다",
  sequence_workflow_version_invalid_dialog_primary_button:
    "현재 버전으로 돌아가기",
  sequence_workflow_version_invalid_dialog_description:
    "현재 버전에 유효하지 않은 필드가 있습니다. 이 필드를 업데이트하거나 변경 사항을 취소할 수 있습니다.",
  back: "뒤로",
  editor_toolbar_image_upload: "업로드",
  editor_toolbar_image_url: "링크",
  choose_file: "파일 선택",
  to_upload: "업로드",
  editor_toolbar_image_popover_url_label: "이미지 링크",
  insert: "삽입",

  set_schedule: "일정 설정",
  sequence_main_schedule_title: "시퀀스 일정",
  start_now: "지금 시작",
  schedule_start: "일정 시작",
  activate_sequence: "시퀀스 활성화",
  sequence_no_credentials_banner_title:
    "Pubrio에서 시퀀스를 보내려면 이메일 또는 메시징 계정을 연결하세요",
  sequence_no_credentials_banner_title_suffix: " · 5분 이내",
  sequence_no_credentials_banner_desc:
    "어떤 시퀀스를 시작하거나 전송하기 전에 이 설정이 필요합니다.",
  sequence_no_credentials_banner_button: "발신 계정 연결",
  sequence_detail_out_of_schedule_popup_message:
    "시퀀스는 활성화되어 있지만 현재 발송 스케줄 외 시간입니다. 지금은 메시지가 전송되지 않습니다. 발송 가능 시간은 {0}이며, {1}부터 전송이 재개됩니다.",
  sequence_list_out_of_schedule_popup_message:
    "안내: 현재 발송 스케줄({0}) 외 시간입니다. 시퀀스는 활성화되지만 첫 메시지 발송은 {1}부터 시작됩니다.",
  dismiss: "닫기",
  edit_schedule: "발송 스케줄 편집",

  ...template_korean,
  broken_steps_popup_message:
    "기본 버전에 일부 단계가 불완전합니다 — 활성화하려면 수정해주세요.",
  broken_step_save_warning_title: "초안으로 저장할까요?",
  broken_step_save_warning_desc_1: "일부 단계가 아직 완료되지 않았습니다.",
  broken_step_save_warning_desc_2:
    "초안으로 저장한 뒤 나중에 돌아와 이어서 작업할 수 있지만, 모든 단계가 완료되기 전에는 이 워크플로우를 활성화할 수 없습니다.",
  broken_step_save_warning_primary_button_text: "초안으로 저장",
  broken_step_save_warning_default_button_text: "계속 편집",
  broken_step_disable_activation_warning_title: "미완료 단계를 저장할까요?",
  broken_step_disable_activation_warning_primary_button_text: "저장하고 일시 중지",
  broken_step_disable_activation_warning_default_button_text: "계속 편집",
  broken_step_disable_activation_warning_desc_1:
    "이 워크플로우는 현재 활성화되어 있습니다.",
  broken_step_disable_activation_warning_desc_2:
    "지금 저장하면 모든 단계가 완료되고 다시 활성화될 때까지 일시 중지됩니다.",
  ...template_korean,
  ...credentialsKorean,
  ...sequence_detail_steps_korean,
  ...sequence_detail_settings_korean,
  ...sequence_detail_logs_korean,
  ...sequence_detail_targets_korean,
  ...sequence_detail_report_ko,

  ...sequence_wizard_ko,
};

export const sequence_hindi = {
  sequence_main_timeout_title:
    "{datetime} पर सक्रिय होने के लिए सेट किया गया है। आप नीचे कभी भी इसे पुनः अनुसूचित कर सकते हैं।",

  /** tabs */
  sequence_tab_overview: "अवलोकन",
  sequence_tab_templates: "टेम्प्लेट्स",
  sequence_tab_analytics: "एनालिटिक्स",
  sequence_tab_meetings: "मीटिंग्स",
  sequence_tab_credentials: "क्रेडेंशियल्स",
  sequence_tab_settings: "सेटिंग्स",

  /** aside */
  sequence_overview_aside_create_new_label: "नया लेबल बनाएं",
  sequence_overview_labels_total:
    "0 वर्कफ़्लो | 1 वर्कफ़्लो | {count} वर्कफ़्लो",

  /** label form */
  sequence_overview_label_create_dialog_name: "लेबल जोड़ें",
  sequence_overview_label_edit_dialog_name: "लेबल रीनेम करें",
  sequence_overview_label_create_dialog_input_label: "नया लेबल नाम दर्ज करें",
  sequence_overview_label_edit_dialog_input_label: "लेबल नाम दर्ज करें",
  sequence_overview_label_create_dialog_input_oplaceholder: "नया लेबल नाम",
  sequence_overview_label_edit_dialog_input_placeholder: "लेबल नाम",
  create_sequence_label_success: "लेबल सफलतापूर्वक बनाया गया",
  create_sequence_label_failed: "लेबल क्रिएशन फेल्ड",
  update_sequence_label_success: "अपडेट सक्सेसफुल",
  update_sequence_label_failed: "अपडेट फेल्ड",

  /** filters */
  sequence_overview_filters_creator: "क्रिएटर",
  sequence_overview_filters_label: "लेबल",
  sequence_overview_filters_starred: "स्टार किए गए",
  sequence_overview_filters_state: "स्टेटस",
  sequence_filter_status_active: "एक्टिव",
  sequence_filter_status_inactive: "इनएक्टिव",

  /** table */
  sequence_overview_table_label_panel_empty:
    "आपने अभी तक कोई लेबल नहीं बनाया है। पहला लेबल बनाने के लिए '⊕' बटन पर क्लिक करें!",
  sequence_overview_label_panel_search_placeholder: "लेबल सर्च करें",
  add_label_to_sequence_successfully: "सफलतापूर्वक जोड़ा गया",
  add_label_to_sequence_failed: "जोड़ने में विफल",
  remove_label_from_sequence_successfully: "सफलतापूर्वक हटाया गया",
  remove_label_from_sequence_failed: "हटाने में विफल",

  sequence_overview_table_name_sequence_name: "वर्कफ़्लो नाम",
  sequence_overview_table_name_people: "पीपल",
  sequence_overview_table_name_click_rate: "क्लिक रेट",
  sequence_overview_table_name_open_rate: "ओपन रेट",
  sequence_overview_table_name_reply_rate: "रिप्लाई रेट",
  sequence_overview_unsave_count:
    "कोई वर्कफ़्लो सिलेक्ट नहीं | 1 वर्कफ़्लो सिलेक्ट | {count} वर्कफ़्लो सिलेक्ट",

  /** create sequence */
  sequence_overview_create_sequence_dialog_name: "नया वर्कफ़्लो",
  sequence_overview_create_sequence_dialog_input_label:
    "वर्कफ़्लो नाम दर्ज करें",
  sequence_overview_create_sequence_dialog_input_placeholder: "वर्कफ़्लो नाम",

  /** detail empty */
  sequence_detail_error_title: "डेटा फ़ेच नहीं किया जा सका",
  sequence_detail_error_desc:
    "लिंक अमान्य हो सकता है या डेटा अनुपलब्ध है। कृपया URL चेक करें या दूसरा आइटम सिलेक्ट करें।",
  sequence_detail_error_back: "वर्कफ़्लो लिस्ट पर वापस जाएं",

  /** detail header */
  sequence_detail_delete: "वर्कफ़्लो डिलीट करें",
  sequence_detail_delete_dialog_title: "वर्कफ़्लो डिलीट करें",
  sequence_detail_delete_dialog_subtitle:
    "यह सभी सेटिंग्स और डेटा सहित पूरे वर्कफ़्लो को डिलीट कर देगा।",
  sequence_detail_delete_dialog_desc:
    "डिलीट होने के बाद वर्कफ़्लो रिकवर नहीं किया जा सकता। क्या आप जारी रखना चाहते हैं?",

  /** detail nav */
  sequence_detail_nav_inbox: "इनबॉक्स",
  sequence_detail_nav_steps: "स्टेप्स",
  sequence_detail_nav_report: "रिपोर्ट",
  sequence_detail_nav_analytics: "एनालिटिक्स",
  sequence_detail_nav_prospects: "प्रॉस्पेक्ट्स",
  sequence_detail_nav_settings: "सेटिंग्स",
  sequence_detail_nav_logs: "लॉग्स",
  sequence_detail_nav_interactions: "इंटरैक्शन्स",

  /** detail step canvas */
  sequence_detail_workflow_time_delay: "डिले",
  sequence_detail_workflow_time_monitor: "मॉनिटर",
  sequence_detail_workflow_time_run_immediately: "तुरंत एक्ज़ीक्यूट",
  sequence_detail_steps_add_first_step: "पहला स्टेप जोड़ें...",

  /** detail step canvas create node */
  sequence_detail_workflow_create_node_level1_title: "आगे क्या होगा?",
  sequence_detail_workflow_create_node_level2_title: "चैनल सिलेक्ट करें",
  sequence_detail_workflow_create_node_level3_title: "कंडीशन/एक्शन टाइप चुनें",

  /** detail step setting panel credential */
  sequence_detail_setting_credential_label: "क्रेडेंशियल:",
  sequence_detail_setting_credential_primary_flag: "प्राइमरी",
  sequence_detail_setting_credential_primary_opeator: "प्राइमरी सेट करें",
  sequence_workflow_unsave_changes_title: "अनसेव्ड चेंजेस",
  sequence_workflow_unsave_changes_desc:
    "आपके पास अनसेव्ड चेंजेस हैं। आप सेव कर सकते हैं या पेज छोड़कर डिस्कार्ड कर सकते हैं।",
  leave: "लीव",
  discard: "डिस्कार्ड",
  sequence_workflow_version_unsaved_changes_description:
    "करंट वर्ज़न में अनसेव्ड चेंजेस हैं। आप एडिट पर वापस जा सकते हैं या सेव कर सकते हैं।",
  sequence_workflow_version_invalid_dialog_title: "अनवैलिडेटेड फील्ड्स",
  sequence_workflow_version_invalid_dialog_primary_button:
    "करंट वर्ज़न पर वापस जाएं",
  sequence_workflow_version_invalid_dialog_description:
    "करंट वर्ज़न में अनवैलिडेटेड फील्ड्स हैं। आप अपडेट कर सकते हैं या चेंजेस डिस्कार्ड कर सकते हैं।",
  back: "बैक",
  editor_toolbar_image_upload: "अपलोड",
  editor_toolbar_image_url: "URL",
  choose_file: "फाइल चुनें",
  to_upload: "अपलोड करें",
  editor_toolbar_image_popover_url_label: "इमेज URL",
  insert: "इंसर्ट",

  set_schedule: "शेड्यूल सेट करें",
  sequence_main_schedule_title: "अनुक्रम शेड्यूल",
  start_now: "अभी शुरू करें",
  schedule_start: "शेड्यूल प्रारंभ",
  activate_sequence: "अनुक्रम सक्रिय करें",
  sequence_no_credentials_banner_title:
    "Pubrio से वर्कफ़्लो भेजने के लिए अपना ईमेल या मैसेजिंग अकाउंट कनेक्ट करें",
  sequence_no_credentials_banner_title_suffix: " · 5 मिनट से कम",
  sequence_no_credentials_banner_desc:
    "किसी भी वर्कफ़्लो को शुरू या भेजने से पहले यह सेटअप आवश्यक है।",
  sequence_no_credentials_banner_button: "सेंडिंग अकाउंट कनेक्ट करें",
  sequence_detail_out_of_schedule_popup_message:
    "वर्कफ़्लो सक्रिय है, लेकिन अभी शेड्यूल्ड सेंडिंग विंडो के बाहर है। इस समय कोई संदेश नहीं भेजा जा रहा है। बिज़नेस घंटे {0} हैं। संदेश भेजना {1} से फिर शुरू होगा।",
  sequence_list_out_of_schedule_popup_message:
    "नोट: अभी आपकी सेंडिंग शेड्यूल विंडो ({0}) के बाहर समय है। वर्कफ़्लो सक्रिय हो जाएगा, लेकिन पहला संदेश {1} तक नहीं भेजा जाएगा।",
  dismiss: "बंद करें",
  edit_schedule: "सेंडिंग शेड्यूल संपादित करें",

  ...template_hindi,
  broken_steps_popup_message:
    "डिफ़ॉल्ट वर्ज़न में कुछ चरण अधूरे हैं — वर्कफ़्लो को सक्रिय करने के लिए उन्हें ठीक करें।",
  broken_step_save_warning_title: "ड्राफ्ट के रूप में सहेजें?",
  broken_step_save_warning_desc_1: "कुछ चरण अभी पूरे नहीं हुए हैं।",
  broken_step_save_warning_desc_2:
    "आप इसे ड्राफ्ट के रूप में सहेजकर बाद में वापस आ सकते हैं, लेकिन जब तक सभी चरण पूरे नहीं हो जाते, यह वर्कफ़्लो सक्रिय नहीं किया जा सकता।",
  broken_step_save_warning_primary_button_text: "ड्राफ्ट के रूप में सहेजें",
  broken_step_save_warning_default_button_text: "संपादन जारी रखें",
  broken_step_disable_activation_warning_title: "अधूरे चरण सहेजें?",
  broken_step_disable_activation_warning_primary_button_text: "सहेजें और रोकें",
  broken_step_disable_activation_warning_default_button_text:
    "संपादन जारी रखें",
  broken_step_disable_activation_warning_desc_1: "यह वर्कफ़्लो अभी सक्रिय है।",
  broken_step_disable_activation_warning_desc_2:
    "अभी सहेजने पर यह तब तक रुका रहेगा जब तक सभी चरण पूरे न हो जाएं और इसे फिर से सक्रिय न किया जाए।",
  ...template_hindi,
  ...credentialsHindi,
  ...sequence_detail_steps_hindi,
  ...sequence_detail_settings_hindi,
  ...sequence_detail_logs_hindi,
  ...sequence_detail_targets_hindi,
  ...sequence_detail_report_hi,
  ...sequence_wizard_hi,
};
